"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardPhotoFallback = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _PropertyCardPhotoFallback = require("./PropertyCardPhotoFallback.styles");
var _excluded = ["altText"];
/**
 * The fallback image to display in a `PropertyCard` when no property photo, Street View
 * nor satellite image is available.
 *
 * @since 8.63.0
 */
var PropertyCardPhotoFallback = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var altText = _ref.altText,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_PropertyCardPhotoFallback.StyledPropertyCardPhotoFallback, (0, _extends2.default)({
    "aria-label": altText,
    ref: forwardedRef,
    viewBox: "0 0 58 62",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/_react.default.createElement("title", null, altText), /*#__PURE__*/_react.default.createElement("path", {
    className: "Fallback__fill",
    d: "M46.5 24.4375V46.3125C46.5 47.5206 45.5206 48.5 44.3125 48.5C43.1044 48.5 42.125 47.5206 42.125 46.3125V24.4375C42.125 23.2294 43.1044 22.25 44.3125 22.25C45.5206 22.25 46.5 23.2294 46.5 24.4375Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "Fallback__fill",
    d: "M37.75 46.3125V20.0625C37.75 18.8544 36.7706 17.875 35.5625 17.875C34.3544 17.875 33.375 18.8544 33.375 20.0625V46.3125C33.375 47.5206 34.3544 48.5 35.5625 48.5C36.7706 48.5 37.75 47.5206 37.75 46.3125Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "Fallback__fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3687 0.50624L55.9938 11.4437C56.8599 11.7569 57.4371 12.579 57.4375 13.5V59.4375C57.4375 60.6456 56.4581 61.625 55.25 61.625H3.34062C1.80631 61.625 0.5625 60.3812 0.5625 58.8469V41.1062C0.568224 40.1553 0.973005 39.2505 1.67813 38.6125L14.4094 27.1937C15.242 26.4423 16.508 26.4423 17.3406 27.1937L22.4375 31.7656V2.56249C22.4337 1.85071 22.7764 1.18157 23.3563 0.768739C23.9434 0.356508 24.6955 0.258418 25.3687 0.50624ZM18.0625 57.25V50.6875H13.6875V57.25H18.0625ZM26.8125 57.25H22.4375V49.5937C22.4375 47.7816 20.9684 46.3125 19.1562 46.3125H12.5938C10.7816 46.3125 9.3125 47.7816 9.3125 49.5937V57.25H4.9375V41.5656L15.875 31.7437L26.8125 41.5656V57.25ZM53.0625 57.25V15.0531L26.8125 5.66875V35.6375L30.0719 38.6125C30.777 39.2505 31.1818 40.1553 31.1875 41.1063V57.25H53.0625Z"
  }));
});
exports.PropertyCardPhotoFallback = PropertyCardPhotoFallback;
PropertyCardPhotoFallback.displayName = 'PropertyCard.PhotoFallback';
PropertyCardPhotoFallback.propTypes = {
  /**
   * Text that will be read by screenreaders when this image is selected.
   */
  altText: _propTypes.default.string
};
PropertyCardPhotoFallback.defaultProps = {
  altText: 'No image available for this property'
};